import React from "react";
import JokeList from "./JokeList";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <JokeList />
    </div>
  );
}
